<script>
import analysisTableStep from 'Arch/enums/analysisTableStep';
import ClientStatusAnalysisColumnVue from 'Modules/contacard/analysisTable/components/columns/ClientStatusAnalysisColumn.vue';

export default {
  name: 'ClientAnalysisStep',
  extends: ClientStatusAnalysisColumnVue,
  data: () => ({
    status: analysisTableStep,
  }),
};
</script>
